<template>
	<ul>
		<LoanApplicationFormNavigationLink
			v-for="link in toValue(links)"
			:key="link.id"
			:link
		/>
	</ul>
</template>

<script setup lang="ts">
import type { LinkType } from "./LinkType";
import type { Ref } from "vue";
import { toValue } from "vue";

defineProps<{
	links: LinkType[] | Ref<LinkType[]>;
}>();
</script>

<style scoped>
ul {
	font-weight: 400;
}
</style>
